<template>
  <!-- Conteudo-->
  <router-view />
  <!-- /Conteudo-->
</template>

<script>
require('@/assets/vendor/bootstrap/css/bootstrap.min.css')
require('@/assets/vendor/font-awesome/css/font-awesome.min.css')
require('@/assets/vendor/datatables/dataTables.bootstrap4.css')
require('@/assets/css/admin.css')
require('@/assets/css/custom.css')
export default {
  data() {
    return {
    };
  },
}
</script>